<template>
  <div class="message-comment">
    <div class="comment-wrp">
      <input type="text" placeholder="Cevabınızı buraya yazınız...">
      <span class="comment-ico">
          <svg-icon class="" type="icon-send"/>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MessageComment'
}
</script>

<style lang="scss">
  @import "../assets/scss/components/message-comment";
</style>
